import { apiGatewayService, ApiType } from "services/api/ApiGatewayService";
import { getLanguage } from "services/language/languageRepository";

export interface NewsPage {
    id: string;
    title: string;
    url?: string;
    excerpt?: string;
    body?: {
        view?: {
            value?: string;
        };
    };
    history?: {
        createdBy?: {
            displayName?: string;
        };
        createdDate?: string;
        lastUpdated?: {
            by?: {
                displayName?: string;
            };
            when?: string;
        };
    };
    authorName?: string;
    dateLabel?: string;
    readTime?: number;
}

export interface NewsPagination {
    limit: number;
    count: number;
    next_cursor?: string;
}

export interface NewsResponse {
    pages: NewsPage[];
    pagination: NewsPagination;
}

const IS_DEV = process.env.GLOBAL_URL?.includes("dev.blancco.cloud");
const LANGUAGE_SPACE_MAP: Record<string, string> = { ja_JP: "JKB", de_DE: "DKS" };

class NewsService {
    private getLanguageParam(): string {
        if (IS_DEV) {
            return "";
        }
        return LANGUAGE_SPACE_MAP[getLanguage().code] ?? "";
    }

    async fetchNews(cursor?: string, limit = 100, abortSignal?: AbortSignal): Promise<NewsResponse> {
        const language = this.getLanguageParam();
        const params = new URLSearchParams({ limit: limit.toString() });
        if (language) {
            params.append("language", language);
        }
        if (cursor) {
            params.append("cursor", cursor);
        }
        return apiGatewayService.invokeApi(`/api/v1/news/NEWS?${params.toString()}`, "GET", null, {
            apiType: ApiType.ARTHUR,
            abortSignal,
        });
    }

    async fetchNewsById(pageId: string, abortSignal?: AbortSignal): Promise<{ page: NewsPage }> {
        const language = this.getLanguageParam();
        const url = language
            ? `/api/v1/news/NEWS?pageId=${pageId}&language=${language}`
            : `/api/v1/news/NEWS?pageId=${pageId}`;
        return apiGatewayService.invokeApi(url, "GET", null, {
            apiType: ApiType.ARTHUR,
            abortSignal,
        });
    }
}

export const newsService = new NewsService();
